<div
  class="mx-sm-5 mx-xs-3 my-sm-5 my-xs-3 select-site d-flex flex-column justify-content-center align-items-center"
>
  <div class="text-container">
    <div class="icon-container ml-auto mr-auto mb-3">
      <img src="assets/svg/ico-building-gray.svg" class="building-icon" />
    </div>
    <div class="text-center mb-4">
      <h2 class="heading">{{ 'NO_SITE_SELECTED' | translate }}</h2>
      <p>{{ 'PLEASE_SELECT_SITE' | translate }}</p>
    </div>
  </div>
</div>
